<template>
  <div 
    class="public-question-chip" 
    :class="{ active: isActive }" 
    :data-id="question._id"
    @click="$emit('click', question._id)"
  >
    <div class="question-title" :title="question.q">{{ question.q }}</div>
    <div class="question-date">{{ formatDate(question.timestamp) }}</div>
  </div>
</template>

<script>
export default {
  name: 'PublicQuestionChipComponent',
  props: {
    question: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }
}
</script>

<style scoped>
.public-question-chip {
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  background-color: rgba(230, 230, 230, 0.9);
  cursor: pointer;
  transition: background-color 0.2s;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.public-question-chip:hover {
  background-color: rgba(210, 210, 210, 0.9);
}

.public-question-chip.active {
  background-color: #a1344e;
}

.public-question-chip.active .question-title,
.public-question-chip.active .question-date {
  color: #ffffff;
}

.question-title {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.question-date {
  font-size: 12px;
  color: #666666;
}
</style>
